import moment from 'moment/moment';
import {getCurrency} from '@utilities/helpers';
import i18n from '@/i18n';

export default {
    additionalOptions(options, previousValues = []) {
        return options
            .map((option) => {
                if (previousValues[option.id]) {
                    option.quantity = previousValues[option.id];
                }
                else{
                    option.quantity = 0;
                }
                option.label = option.name;
                option.type = option.category.name;
                option.gross_price = option.price*100;
                return option;
            })
            //order by type and the by label
            .sort((a, b) => {
                if (a.type === b.type) {
                    return a.label.localeCompare(b.label);
                }
                return a.type.localeCompare(b.type);
            });
    },
    mapAddresses(addresses) {
        const flightDetails = {number: null, time: null};
        const resultAddresses = [...addresses].map((address) => {
            if (address.is_airport) {
                flightDetails.number = address.flight_number;
                flightDetails.time = address.comments?moment(address.comments, 'HH:mm').format('HH:mm'):null;
            }
            address.city = address.city?address.city:address.coords.city;
            address.zip = address.zip?address.zip:address.coords.zip;
            return address;
        });
        return {addresses: resultAddresses, flightDetails: flightDetails};
    },
    BOVehiclesToTravels(vehicles, searchParameters, passengersCountFilter = false, return_travel = false) {
        if(passengersCountFilter){
            vehicles = vehicles.filter(v => v.vehicleInfo.passengersCount >= passengersCountFilter);
        }
        return vehicles.filter(v => v.vehicleInfo.name).map((vehicle) => {
            return {
                code: vehicle.vehicleId,
                currency: getCurrency(),
                end_is_airport: return_travel ? searchParameters.start_is_airport : searchParameters.end_is_airport,
                end_place: return_travel ? searchParameters.start_place : searchParameters.end_place,
                gross_price: vehicle.value.grossPrice * 100,
                id: vehicle.vehicleId,
                is_short_time: false,
                net_price: vehicle.value.netPrice * 100,
                start_is_airport: return_travel ? searchParameters.end_is_airport : searchParameters.start_is_airport,
                start_place: return_travel ? searchParameters.end_place : searchParameters.start_place,
                vat: vehicle.value.vat * 100,
                vehicle_id: vehicle.vehicleId,
                vehicle:
                    {
                        id: vehicle.vehicleId,
                        code: vehicle.vehicleId,
                        name: vehicle.vehicleInfo.name,
                        brand: '',
                        description: vehicle.vehicleInfo.description,
                        passengers_number_min: 1,
                        passengers_number_max: vehicle.vehicleInfo.passengersCount,
                        hand_luggage_amount: vehicle.vehicleInfo.luggageCount,
                        checked_baggage_amount: vehicle.vehicleInfo.luggageCount,
                        is_available_in_48h: false,
                        is_visible: true,
                        is_eco: false,
                        order: 1,
                        photo_id: vehicle.vehicleInfo.image?vehicle.vehicleInfo.image.id:null,
                    },
            };
        });
    },

    parseAPIErrors(error) {
        const ret_errors = [];
        if(error.graphQLErrors && error.graphQLErrors.length){
            error.graphQLErrors.forEach((error_row) => {
                let errorCode = null;
                let errorMsg = error_row.extensions.validation?Object.values(error_row.extensions.validation)[0][0].message:error_row.message;
                errorCode = error_row.extensions.validation?Object.values(error_row.extensions.validation)[0][0].code:error_row.code;
                errorCode = errorCode?errorCode:errorMsg;

                //use code translation if exists otherwise show en api generated error
                if(i18n.tc('validation.' + errorCode) !== 'validation.' + errorCode){
                    errorMsg = i18n.tc('validation.' + errorCode);
                }
                ret_errors.push(errorMsg);
            });
            return ret_errors;
        }
        else{
            return [JSON.stringify(error)];
        }
    },

    parseAPIError(error) {
        return this.parseAPIErrors(error)[0];
    },
};
